export const slides = [
  {
    id: 1,
    className: 'slider1',
    content: {
      desc: 'Enhance Your Living Space with Elegance',
      title: 'Luxury Furniture for Every Style',
      subDesc:
        'Explore our premium collection of modern and classic furniture that complements your taste. Enjoy your shopping today.',
      link: '/shop',
    },
  },
  {
    id: 2,
    className: 'slider2',
    content: {
      desc: 'Create a Cozy and Stylish Home',
      title: 'Comfort Meets Elegance',
      subDesc:
        'Upgrade your home with our stunning range of furniture that blends comfort and style effortlessly.',
      link: '/shop',
    },
  },
  {
    id: 3,
    className: 'slider3',
    content: {
              desc: 'Discover our best furniture collection from home',
              title: 'Stylish Furniture Brings Beauty',
              subDesc:
                'Great furniture can bring beauty at your home, So buy our popular and stylish furniture.',
              link: '/shop',
            },
  },
];
